import { Component, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { FieldHandlerValidator, TextFieldHandler } from '@vendasta/auxiliary-data-components';
import { AutomationVariableMenuComponent } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.component';
import { insertVariable } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.service';
import { ALL_VARIABLE_MENU_DATA_TYPES } from '../../../../../common/constants';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

export class TemplateableFieldHandler extends TextFieldHandler {
  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<AuxiliaryDataTemplateableFieldRendererComponent>(
      AuxiliaryDataTemplateableFieldRendererComponent,
    );
    component.instance.control = this.formControl;
    component.instance.label = this.label;
    component.instance.validators = this.validators;
    component.instance.readOnly = this.readOnly;
  }
}

@Component({
  template: `
    <glxy-form-field required="true">
      <glxy-label>Label</glxy-label>
      <textarea matInput id="custom-field" [formControl]="control" [required]="true"></textarea>
      <automata-automation-variable-menu
        [supportedDataTypes]="allDataTypes"
        [dontIncludeDefaultCategories]="true"
        (variableSelected)="insertVariable('custom-field', control, $event)"
        matSuffix
        useGalaxyCompat="true"
      ></automata-automation-variable-menu>
    </glxy-form-field>
  `,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    AutomationVariableMenuComponent,
  ],
})
export class AuxiliaryDataTemplateableFieldRendererComponent {
  control!: UntypedFormControl;
  label!: string;
  validators!: FieldHandlerValidator[];
  readOnly!: boolean;
  allDataTypes = ALL_VARIABLE_MENU_DATA_TYPES;

  insertVariable(elementID: string, control: UntypedFormControl, variable: string): void {
    insertVariable(elementID, control, variable);
  }
}
